/** @typedef {Readonly<{ collapsible?: boolean, onListItemClick?: () => void }>} Props */
/** @typedef {import('config/local/NavigationItem').default} NavigationItem */
/** @typedef {Omit<import('App/shared/NavigationListComponent').Props, 'location' | 'settings'>} NavigationListProps */

import React from 'react';

import { translate } from 'App/Internationalization';
import NavigationList from 'App/shared/NavigationList';
import RoleGate from 'App/shared/RoleGate';
import navigation from 'config/local/navigation';

/** @extends {React.Component<Props>} */
export default class HomeownerNavigationList extends React.Component {
	render() {
		/** @type {NavigationItem[]} */
		const links = navigation.homeowner.linkList.filter(
			(link) => link !== null
		);

		return (
			<RoleGate allowedRoles={['homeowner']}>
				<NavigationList
					collapsible={this.props.collapsible}
					heading={translate('homeowner.nav.heading')}
					links={links}
					onListItemClick={this.props.onListItemClick}
				/>
			</RoleGate>
		);
	}
}
